export enum Language {
  DE = "de",
  EN = "en"
}

export type LanguageString = "de" | "en";
